export default __webpack_public_path__ + "static/media/regulatory--trucks-only--g1.2caa4b16.png";